import { URLS } from '../../constants';
import apiClient from '../client';

const schedulingApis = {
  getScheduleEventById: ({
    id,
    appointmentRecurrenceId,
  }: {
    id: string;
    appointmentRecurrenceId: any;
  }) => {
    return apiClient.post(URLS.getScheduleEventById, {
      data: {
        id,
        appointmentRecurrenceId,
      },
    });
  },
  getNewNoteByCode: ({
    sessionNoteTemplateId,
    childPayerId,
    appointmentId,
    appointmentRecurrenceId,
  }: {
    sessionNoteTemplateId: any;
    childPayerId: any;
    appointmentId: any;
    appointmentRecurrenceId: any;
  }) => {
    return apiClient.post(URLS.getNoteByCode, {
      data: {
        sessionNoteTemplateId,
        childPayerId,
        appointmentId,
        appointmentRecurrenceId,
      },
    });
  },
  getMultipleNoteByCode: ({ authorizationCode }: { authorizationCode: any }) => {
    return apiClient.post(URLS.getMultipleNoteByCode, {
      data: {
        authorizationCode,
      },
    });
  },
  checkSessionNoteExists: ({
    appointmentId,
    sessionNoteDataId,
    billingCode,
  }: {
    appointmentId: any;
    sessionNoteDataId: string;
    billingCode: string;
  }) => {
    return apiClient.post(URLS.checkSessionNoteExists, {
      data: {
        appointmentId,
        sessionNoteDataId,
        billingCode,
      },
    });
  },
  getNoteById: ({
    sessionNoteDataId,
    appointmentId,
    isExistingNote,
    appointmentDate,
    appointmentRecurrenceId,
  }: {
    sessionNoteDataId: any;
    appointmentId: any;
    isExistingNote: any;
    appointmentDate: any;
    appointmentRecurrenceId: any;
  }) => {
    return apiClient.post(URLS.getNoteById, {
      data: {
        sessionNoteDataId,
        appointmentId,
        isExistingNote,
        appointmentDate,
        appointmentRecurrenceId,
      },
    });
  },
  copySessionNoteById: ({
    sessionNoteDataId,
    appointmentWith,
    currentDateAndTime,
  }: {
    sessionNoteDataId: any;
    appointmentWith: any;
    currentDateAndTime: any;
  }) => {
    return apiClient.post(URLS.copySessionNote, {
      data: {
        sessionNoteDataId,
        appointmentWith,
        currentDateAndTime,
      },
    });
  },
  deleteSessionNoteById: ({
    sessionNoteDataId,
    isFromExistingNote,
  }: {
    sessionNoteDataId: any;
    isFromExistingNote: any;
  }) => {
    return apiClient.post(URLS.deleteSessionNoteById, {
      data: {
        sessionNoteDataId,
        isFromExistingNote,
      },
    });
  },
  getClientProviderDetails: ({
    providerId,
    clientId,
    appointmentId,
    appointmentRecurrenceId,
  }: {
    providerId: any;
    clientId: any;
    appointmentId: any;
    appointmentRecurrenceId: any;
  }) => {
    return apiClient.post(URLS.clientProviderDetails, {
      data: {
        providerId,
        clientId,
        appointmentId,
        appointmentRecurrenceId,
      },
    });
  },
  getInterventionClientProviderDetails: ({
    providerId,
    clientId,
    organizationServiceId,
  }: {
    providerId: any;
    clientId: any;
    organizationServiceId: any;
  }) => {
    return apiClient.post(URLS.interventionClientProviderDetails, {
      data: {
        providerId,
        clientId,
        organizationServiceId,
      },
    });
  },
  getProgramClientProviderDetails: ({
    providerId,
    clientId,
    authorizationCodeId,
  }: {
    providerId: any;
    clientId: any;
    authorizationCodeId: any;
  }) => {
    return apiClient.post(URLS.clientProviderData, {
      data: {
        providerId,
        clientId,
        authorizationCodeId,
      },
    });
  },
  saveNoteByCode: ({
    appointmentId,
    authorizationCode,
    sessionTemplateId,
    sessionNoteData,
    createdBy,
    modifiedBy,
    sessionNotesDataId,
    appointmentWith,
    organizationLogo,
    authorizationCodes,
    unitOfService,
    childPayerId,
    appointmentRecurrenceId,
    isExistingSessionNoteSelected,
    name,
    cosignedBy,
    coSignatureData,
    isProgressNote,
    progressNoteCreationDate,
    logoConfig,
    isSessionNoteDataEdited,
  }: {
    appointmentId: any;
    authorizationCode: any;
    sessionTemplateId: any;
    sessionNoteData: any;
    createdBy: any;
    modifiedBy: any;
    sessionNotesDataId: any;
    appointmentWith: any;
    organizationLogo: string;
    authorizationCodes: any;
    unitOfService: any;
    childPayerId: any;
    appointmentRecurrenceId?: any;
    isExistingSessionNoteSelected?: boolean;
    name: any;
    cosignedBy: any;
    coSignatureData: any;
    isProgressNote?: boolean;
    progressNoteCreationDate?: string;
    logoConfig: any;
    isSessionNoteDataEdited: boolean;
  }) => {
    return apiClient.post(URLS.saveAddNewNote, {
      data: {
        appointmentId,
        authorizationCode,
        sessionTemplateId,
        sessionNoteData,
        createdBy,
        modifiedBy,
        sessionNotesDataId,
        appointmentWith,
        organizationLogo,
        authorizationCodes,
        unitOfService,
        childPayerId,
        appointmentRecurrenceId,
        isExistingSessionNoteSelected,
        name,
        cosignedBy,
        coSignatureData,
        isProgressNote,
        progressNoteCreationDate,
        logoConfig,
        isSessionNoteDataEdited,
      },
    });
  },
  editScheduleEvent: ({
    title,
    eventId,
    providerSignature,
    startTime,
    endTime,
    modifiedBy,
    authorizationCodes,
    primaryProviderId,
    providersNameSignature,
    duration,
    timezone,
    isAuthorizationCodesEdited,
    isServiceProviderChecked,
    isClientChecked,
    clientSignature,
    clientNameSignatureForm,
    userTimeZone,
    childPayorId,
    signedOn,
    appointmentRecurrenceId,
    isAppointmentRecurrence,
    futureAppointmentsOnly,
    isRepeat,
    repeatConfiguration,
    placeOfService,
    locationAddress,
    additionalParticipantData,
    authorizationCodeId,
    clientSignatureChanged,
    providerSignatureChange,
  }: {
    title: any;
    eventId: string;
    providerSignature: string;
    startTime: string;
    endTime: string;
    modifiedBy: string;
    authorizationCodes: any;
    primaryProviderId: any;
    providersNameSignature: string;
    duration: any;
    timezone: any;
    isAuthorizationCodesEdited: any;
    isServiceProviderChecked: any;
    isClientChecked: any;
    clientSignature: any;
    clientNameSignatureForm: any;
    userTimeZone: any;
    childPayorId: any;
    signedOn: any;
    appointmentRecurrenceId: any;
    isAppointmentRecurrence: any;
    futureAppointmentsOnly: any;
    isRepeat: any;
    repeatConfiguration: any;
    placeOfService: any;
    locationAddress: any;
    additionalParticipantData: any;
    authorizationCodeId: any;
    clientSignatureChanged: any;
    providerSignatureChange: any;
  }) => {
    return apiClient.post(URLS.editScheduleEvent, {
      data: {
        title,
        eventId,
        providerSignature,
        startTime,
        endTime,
        modifiedBy,
        authorizationCodes,
        primaryProviderId,
        providersNameSignature,
        duration,
        timezone,
        isAuthorizationCodesEdited,
        isServiceProviderChecked,
        isClientChecked,
        clientSignature,
        clientNameSignatureForm,
        userTimeZone,
        childPayorId,
        signedOn,
        appointmentRecurrenceId,
        isAppointmentRecurrence,
        futureAppointmentsOnly,
        isRepeat,
        repeatConfiguration,
        placeOfService,
        locationAddress,
        additionalParticipantData,
        authorizationCodeId,
        clientSignatureChanged,
        providerSignatureChange,
      },
    });
  },
  editCompleteScheduleEvent: ({
    title,
    eventId,
    providerSignature,
    startTime,
    endTime,
    modifiedBy,
    authorizationCodes,
    primaryProviderId,
    providersNameSignature,
    duration,
    timezone,
    isAuthorizationCodesEdited,
    isServiceProviderChecked,
    isClientChecked,
    clientSignature,
    clientNameSignatureForm,
    userTimeZone,
    childPayorId,
    signedOn,
    appointmentRecurrenceId,
    isAppointmentRecurrence,
    futureAppointmentsOnly,
    isRepeat,
    repeatConfiguration,
    placeOfService,
    locationAddress,
    additionalParticipantData,
    authorizationCodeId,
    clientSignatureChanged,
    providerSignatureChange,
  }: {
    title: any;
    eventId: string;
    providerSignature: string;
    startTime: string;
    endTime: string;
    modifiedBy: string;
    authorizationCodes: any;
    primaryProviderId: any;
    providersNameSignature: string;
    duration: any;
    timezone: any;
    isAuthorizationCodesEdited: any;
    isServiceProviderChecked: any;
    isClientChecked: any;
    clientSignature: any;
    clientNameSignatureForm: any;
    userTimeZone: any;
    childPayorId: any;
    signedOn: any;
    appointmentRecurrenceId: any;
    isAppointmentRecurrence: any;
    futureAppointmentsOnly: any;
    isRepeat: any;
    repeatConfiguration: any;
    placeOfService: any;
    locationAddress: any;
    additionalParticipantData: any;
    authorizationCodeId: any;
    clientSignatureChanged: any;
    providerSignatureChange: any;
  }) => {
    return apiClient.post(URLS.editCompleteScheduleEvent, {
      data: {
        title,
        eventId,
        providerSignature,
        startTime,
        endTime,
        modifiedBy,
        authorizationCodes,
        primaryProviderId,
        providersNameSignature,
        duration,
        timezone,
        isAuthorizationCodesEdited,
        isServiceProviderChecked,
        isClientChecked,
        clientSignature,
        clientNameSignatureForm,
        userTimeZone,
        childPayorId,
        signedOn,
        appointmentRecurrenceId,
        isAppointmentRecurrence,
        futureAppointmentsOnly,
        isRepeat,
        repeatConfiguration,
        placeOfService,
        locationAddress,
        additionalParticipantData,
        authorizationCodeId,
        clientSignatureChanged,
        providerSignatureChange,
      },
    });
  },
  completeScheduleEvent: ({
    appointmentId,
    sessionNotesDataId,
    childPayerId,
    isIgnored,
    appointmentRecurrenceId,
    authorizationCodeId,
    code,
    ignoreFeeScheduleCheck,
  }: {
    appointmentId: any;
    sessionNotesDataId: any;
    childPayerId: any;
    isIgnored: any;
    appointmentRecurrenceId: any;
    authorizationCodeId: any;
    code: any[];
    ignoreFeeScheduleCheck: boolean;
  }) => {
    return apiClient.post(URLS.completeScheduleEvent, {
      data: {
        appointmentId,
        sessionNotesDataId,
        childPayerId,
        isIgnored,
        appointmentRecurrenceId,
        authorizationCodeId,
        code,
        ignoreFeeScheduleCheck,
      },
    });
  },

  getAuthCodes: ({ id, appointmentRecurrenceId }: { id: any; appointmentRecurrenceId: any }) => {
    return apiClient.post(URLS.getAuthCodes, {
      data: {
        id,
        appointmentRecurrenceId,
      },
    });
  },
  setAuthCodes: ({
    startTime,
    endTime,
    duration,
    id,
    appointmentRecurrenceId,
    authorizationCodes,
  }: {
    startTime: any;
    endTime: any;
    duration: any;
    id: any;
    appointmentRecurrenceId: any;
    authorizationCodes: any;
  }) => {
    return apiClient.post(URLS.setAuthCodes, {
      data: {
        startTime,
        endTime,
        duration,
        id,
        appointmentRecurrenceId,
        authorizationCodes,
      },
    });
  },
  getClinicianAvailability: ({
    clinicianId,
    appointmentStartDate,
    appointmentEndDate,
    appointmentWith,
  }: {
    clinicianId: string | number;
    appointmentStartDate: string;
    appointmentEndDate: string;
    appointmentWith?: { id: any; type: string } | null;
  }) => {
    return apiClient.post(URLS.getClinicianAvailability, {
      data: {
        clinicianId,
        appointmentStartDate,
        appointmentEndDate,
        ...(appointmentWith ? { appointmentWith } : {}),
      },
    });
  },
  downloadTechnicianAvailability: ({ availabilityDate }: { availabilityDate: string }) => {
    return apiClient.post(URLS.downloadTechnicianAvailability, {
      data: {
        availabilityDate,
      },
    });
  },
};
export default schedulingApis;
